/**
 * ResumeConfig — the /resume URL: the saved-character roster.
 *
 * /resume is the "continue a hero" surface for persistence testing — it shows
 * the FULL CharacterSelectScreen roster (every character you've created, with
 * level + class + last location) so you can RESUME one (loads its full persisted
 * state — level, gear, inventory, quests, gold, position) or ABANDON (delete) it.
 *
 * Unlike /intro, it does NOT reset per-tab state (resetOnLoad: false) and does
 * NOT create a fresh hero — the whole point is to pick up an existing one where
 * you left it. `fullRoster: true` forces CharacterSelectScreen (resume + abandon)
 * over the quick 6-button picker.
 *
 * Note: the resumed hero re-enters on this mode's map (the calm Tidewend hub);
 * full STATE resumes, but spawning back at each hero's exact last map is a deeper
 * room-join change (DevConfig.defaultMap resolves the join map once at boot) —
 * tracked as a follow-up. The roster shows each hero's last map so they're still
 * distinguishable.
 *
 * Wiring (mirrors /intro):
 *   - applyModeUrlCoercion.ts → coerceModeUrl injects fullRoster (quickPicker=0
 *     + pickCharacter=1) + map + preset
 *   - HomeModePicker.tsx → the "Resume" card navigates here
 */

export const RESUME_CONFIG = {
  // Continue an existing hero — never wipe progress on visit.
  resetOnLoad: false,

  // Calm village hub so a resumed hero doesn't drop into combat on arrival.
  preset: 'live-lobby' as const,
  skipSplash: true,
  skipLogin: true,

  // Show the full roster (resume + abandon), not the quick picker.
  fullRoster: true,
} as const;
